import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Award, Sparkles } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * WalletTierBadge — shows the connected wallet's social-influencer tier.
 * Visible only when user reached Bronze or higher (NFT-eligible).
 * Pulse-glow animation on Bronze+, harder glow as tier rises.
 */
export default function WalletTierBadge({ address }) {
    const [tier, setTier] = useState(null);
    const [conv, setConv] = useState(0);

    useEffect(() => {
        if (!address) { setTier(null); return; }
        let cancelled = false;
        const fetchTier = async () => {
            try {
                const r = await fetch(`${API}/api/social-sharing/me/${address}`);
                const d = await r.json();
                if (cancelled) return;
                setTier(d.tier_info || null);
                setConv(d.total_conversions || 0);
            } catch (e) { /* silent */ }
        };
        fetchTier();
        const i = setInterval(fetchTier, 60000);
        return () => { cancelled = true; clearInterval(i); };
    }, [address]);

    if (!tier || !tier.nft_eligible) return null;

    const tierLabel = tier.label || 'Tier';
    const tooltip = tier.next_tier
        ? `${tierLabel} ×${tier.multiplier} · ${conv}/${tier.next_tier.min_conversions} conv. vers ${tier.next_tier.label}`
        : `${tierLabel} ×${tier.multiplier} · niveau MAX`;

    return (
        <Link
            to="/social-leaderboard"
            data-testid={`wallet-tier-badge-${tier.id}`}
            className="hidden sm:flex items-center gap-1.5 px-2 py-1.5 rounded-lg border transition-all relative group"
            style={{
                borderColor: `${tier.color}60`,
                backgroundColor: `${tier.color}15`,
                boxShadow: `0 0 12px ${tier.color}55, inset 0 0 8px ${tier.color}20`,
            }}
            title={tooltip}
            aria-label={`Influencer tier ${tierLabel}`}
        >
            <Award className="w-4 h-4" style={{ color: tier.color }} />
            <span className="text-xs font-bold" style={{ color: tier.color }}>{tierLabel}</span>
            {tier.id === 'diamond' && <Sparkles className="w-3 h-3 text-white animate-pulse" />}
            {/* Pulse halo */}
            <span
                className="absolute inset-0 rounded-lg pointer-events-none animate-pulse opacity-50"
                style={{ boxShadow: `0 0 16px ${tier.color}` }}
                aria-hidden="true"
            />
        </Link>
    );
}
